
import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import {
  obtenerEstadisticasNuevaEncuesta,
  obtenerComentariosNuevaEncuesta,
  descargarExcelNuevaEncuesta,
  obtenerConfiguracionEnvioEncuestas,
  actualizarConfiguracionEnvioEncuestas,
} from "../../../services/apis_jefatura";
import { getMesones } from "../../../services/apis_funcionarios";

const evaluaciones = [
  { clave: "excelente", nombre: "Excelente" },
  { clave: "buena", nombre: "Buena" },
  { clave: "regular", nombre: "Regular" },
  { clave: "mala", nombre: "Mala" },
  { clave: "muy_mala", nombre: "Muy mala" },
];

function NuevaEncuestaTab() {
  const [datos, setDatos] = useState(null);
  const [comentarios, setComentarios] = useState([]);
  const [mesones, setMesones] = useState([]);
  const [mesonSeleccionado, setMesonSeleccionado] = useState("");
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [filtros, setFiltros] = useState({});
  const [envioAutomatico, setEnvioAutomatico] = useState(null);
  const [cargandoConfiguracion, setCargandoConfiguracion] = useState(true);
  const [actualizandoConfiguracion, setActualizandoConfiguracion] = useState(false);
  const [errorConfiguracion, setErrorConfiguracion] = useState("");

  useEffect(() => {
    let activo = true;

    async function cargarConfiguracion() {
      try {
        const respuesta = await obtenerConfiguracionEnvioEncuestas();

        if (activo) {
          setEnvioAutomatico(respuesta.envio_automatico);
          setErrorConfiguracion("");
        }
      } catch (err) {
        if (activo) {
          setErrorConfiguracion(
            err.message || "No fue posible consultar el estado del envío automático."
          );
        }
      } finally {
        if (activo) {
          setCargandoConfiguracion(false);
        }
      }
    }

    cargarConfiguracion();

    return () => {
      activo = false;
    };
  }, []);

  useEffect(() => {
      let activo = true;

      async function cargarMesones() {
        try {
          const respuesta = await getMesones();

          if (activo) {
            setMesones(Array.isArray(respuesta) ? respuesta : []);
          }
        } catch (err) {
          console.error("Error al cargar mesones:", err);
          if (activo) {
            setError("No fue posible cargar la lista de mesones.");
          }
        }
      }

      cargarMesones();

      return () => {
        activo = false;
      };
    }, []);


  useEffect(() => {
    let activo = true;

    async function cargar() {
      setCargando(true);
      setError("");

      try {
          const [respuesta, respuestaComentarios] = await Promise.all([
              obtenerEstadisticasNuevaEncuesta(filtros),
              obtenerComentariosNuevaEncuesta(filtros),
          ]);

          if (activo) {
              setDatos(respuesta);
              setComentarios(respuestaComentarios.comentarios || []);
          }
      } catch (err) {
        if (activo) {
          setError(err.message || "No fue posible cargar las estadísticas.");
        }
      } finally {
        if (activo) setCargando(false);
      }
    }

    cargar();

    return () => {
      activo = false;
    };
  }, [filtros]);

  const total = datos?.total_encuestas ?? 0;
  const completas = datos?.resolucion?.completa ?? 0;
  const porcentajeResueltas = total
    ? ((completas / total) * 100).toFixed(1)
    : "0.0";

  const aplicarFiltros = (event) => {
    event.preventDefault();

    if (fechaInicio && fechaFin && fechaInicio > fechaFin) {
      setError("La fecha de inicio no puede superar la fecha de término.");
      return;
    }

    setFiltros({fechaInicio, fechaFin, mesonId: mesonSeleccionado});
  };

  const limpiarFiltros = () => {
    setFechaInicio("");
    setFechaFin("");
    setMesonSeleccionado("");
    setFiltros({});
  };
  const cambiarConfiguracionEnvio = async () => {
    try {
      setActualizandoConfiguracion(true);
      setErrorConfiguracion("");
      const nuevoEstado = !envioAutomatico;
      const respuesta = await actualizarConfiguracionEnvioEncuestas(
        nuevoEstado
      );
      setEnvioAutomatico(respuesta.envio_automatico);
    } catch (err) {
      setErrorConfiguracion(
        err.message || "No fue posible actualizar la configuración."
      );
    } finally {
      setActualizandoConfiguracion(false);
    }
  };

  const descargarExcel = async () => {


    try {
      setError("");
      await descargarExcelNuevaEncuesta(filtros);
    } catch (err) {
      setError(err.message || "No fue posible descargar el Excel.");
    }
  };

  return (
    <div>
      <h5 className="mb-3">Resultados de satisfacción de la atención</h5>
      <Card className="mb-4">
        <Card.Body>
          <h6>Envío automático de encuestas</h6>

          {errorConfiguracion && (
            <Alert variant="danger" className="mb-3">
              {errorConfiguracion}
            </Alert>
          )}

          {envioAutomatico === null && !cargandoConfiguracion && (
            <Button
              variant="outline-primary"
              size="sm"
              className="mb-3"
              onClick={() => window.location.reload()}
            >
              Reintentar consulta
            </Button>
          )}

          {cargandoConfiguracion ? (
            <div className="d-flex align-items-center gap-2">
              <Spinner animation="border" size="sm" />
              <span>Consultando configuración...</span>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span>
                Envío de correo automático{" "}
                <strong>
                  {envioAutomatico === null
                   ? "desconocido"
                   : envioAutomatico
                    ? "activado"
                    : "desactivado"}
                </strong>
              </span>

              <Button
              variant={envioAutomatico ? "outline-danger" : "outline-success"}
              onClick={cambiarConfiguracionEnvio}
              disabled={ actualizandoConfiguracion || cargandoConfiguracion ||
                envioAutomatico === null
              }
              >
                {actualizandoConfiguracion ? (
                  <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Actualizando...
                  </>
                  ) : envioAutomatico ? (
                    "Desactivar envío de correos"
                  ) : (
                    "Activar envío de correos"
                    )}
                    </Button>
            </div>
          )}
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <Form onSubmit={aplicarFiltros}>
            <Row className="g-3 align-items-end">
              <Col xs={12} md={4}>
                <Form.Label>Mesón de atención</Form.Label>
                <Form.Select
                  value={mesonSeleccionado}
                  onChange={(e) => setMesonSeleccionado(e.target.value)}
                >
                  <option value="">Todos los mesones</option>
                    {mesones.map((meson) => (
                      <option key={meson.id} value={meson.id}>
                        {meson.nombre}
                      </option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={12} md={4}>
                <Form.Label>Fecha de inicio</Form.Label>
                <Form.Control
                  type="date"
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                />
              </Col>

              <Col xs={12} md={4}>
                <Form.Label>Fecha de término</Form.Label>
                <Form.Control
                  type="date"
                  value={fechaFin}
                  onChange={(e) => setFechaFin(e.target.value)}
                />
              </Col>

              <Col xs={12} className="d-flex gap-2 flex-wrap">
                <Button type="submit">
                  Aplicar
                </Button>

                <Button
                  type="button"
                  variant="outline-secondary"
                  onClick={limpiarFiltros}
                >
                  Limpiar
                </Button>

                <Button
                  type="button"
                  variant="outline-success"
                  onClick={descargarExcel}
                  disabled={cargando}
                >
                  Descargar Excel
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {error && <Alert variant="danger">{error}</Alert>}

      {cargando ? (
        <div className="text-center py-5">
          <Spinner animation="border" />
          <p className="mt-3">Cargando estadísticas...</p>
        </div>
      ) : datos && (
        <>
          <Row className="g-3 mb-4">
            {[
              {
                titulo: "Encuestas respondidas",
                valor: total,
                detalle: "En el período seleccionado",
              },
              {
                titulo: "Claridad promedio",
                valor: datos.claridad_promedio ?? "—",
                detalle: "Escala de 1 a 5",
              },
              {
                titulo: "Consultas resueltas",
                valor: `${porcentajeResueltas}%`,
                detalle: `${completas} respuestas completamente resueltas`,
              },
              {
                titulo: "Con comentarios",
                valor: datos.total_comentarios ?? 0,
                detalle: "Encuestas con comentarios",
              },
            ].map((indicador) => (
              <Col xs={12} md={6} xl={3} key={indicador.titulo}>
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <div className="text-muted small">{indicador.titulo}</div>
                    <h3 className="my-2">{indicador.valor}</h3>
                    <div className="text-muted small">{indicador.detalle}</div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Row className="g-3">
            <Col xs={12} lg={6}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h6>Resolución de consultas</h6>
                  <div className="mt-3">
                    <p>Completamente: {datos.resolucion?.completa ?? 0}</p>
                    <p>Parcialmente: {datos.resolucion?.parcial ?? 0}</p>
                    <p>Pendiente: {datos.resolucion?.pendiente ?? 0}</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} lg={6}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h6>Evaluación general de la atención</h6>
                  <div className="mt-3">
                    {evaluaciones.map(({ clave, nombre }) => (
                      <p key={clave}>
                        {nombre}: {datos.evaluacion_general?.[clave] ?? 0}
                      </p>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}
  <Card className="mt-4">
    <Card.Body>
      <Card.Title>Comentarios de estudiantes</Card.Title>

      {comentarios.length === 0 ? (
        <p className="text-muted mb-0">
          No hay comentarios para los filtros seleccionados.
        </p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Mesón</th>
                <th>Evaluación</th>
                <th>Resolución</th>
                <th>Comentario</th>
              </tr>
            </thead>
            <tbody>
              {comentarios.map((item, index) => (
                <tr key={index}>
                  <td>
                    {new Date(item.fecha).toLocaleDateString("es-CL")}
                  </td>
                  <td>{item.meson}</td>
                  <td>{item.evaluacion}</td>
                  <td>{item.resolucion}</td>
                  <td>{item.comentario}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card.Body>
  </Card>
    </div>
  );
}

export default NuevaEncuestaTab;
